import { ChainId, getChain, type ChainIdValue } from '@sirius-cybernetics-42/product-config'

import type { ChainDefinition, ChainKey } from '../types'

import { DEFAULT_NATIVE_GAS_RESERVE, TESTNET_NATIVE_GAS_RESERVE } from './_shared'

const UI_OVERRIDES: Record<
  ChainIdValue,
  { configured: boolean; nativeGasReserve: string }
> = {
  [ChainId.INFINITE_MAINNET]: {
    configured: true,
    nativeGasReserve: DEFAULT_NATIVE_GAS_RESERVE,
  },
  [ChainId.INFINITE_TESTNET]: {
    configured: true,
    nativeGasReserve: TESTNET_NATIVE_GAS_RESERVE,
  },
  [ChainId.INFINITE_CREATIVE]: {
    configured: true,
    nativeGasReserve: DEFAULT_NATIVE_GAS_RESERVE,
  },
}

/** Adapta la definición declarativa de product-config al shape UI del frontend. */
export function buildChainDefinition(chainId: ChainIdValue): ChainDefinition {
  const base = getChain(chainId)
  const ui = UI_OVERRIDES[chainId]
  return {
    key: base.key as ChainKey,
    chainId,
    configured: ui.configured,
    displayName: base.displayName,
    nativeCurrency: base.nativeCurrency,
    nativeGasReserve: ui.nativeGasReserve,
    contracts: base.contracts,
    explorer: base.explorer,
  }
}

export function buildAllChains(): Record<ChainIdValue, ChainDefinition> {
  return {
    [ChainId.INFINITE_MAINNET]: buildChainDefinition(ChainId.INFINITE_MAINNET),
    [ChainId.INFINITE_TESTNET]: buildChainDefinition(ChainId.INFINITE_TESTNET),
    [ChainId.INFINITE_CREATIVE]: buildChainDefinition(ChainId.INFINITE_CREATIVE),
  }
}
